import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Buttons from 'theme/components/Buttons.style';
import * as Modal from 'theme/components/Modal.style';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export default function UnsavedChangesModal({
  isOpen,
  onSave,
  onDiscard,
  onCancel,
}: UnsavedChangesModalProps): JSX.Element {
  const { t } = useTranslation('pageTeam');

  return (
    <Modal.Container
      onClose={onCancel}
      open={isOpen}
      PaperComponent={Modal.Card}
    >
      <Modal.Title id="unsaved-changes-dialog-title">
        {t('unsavedChanges.title')}
      </Modal.Title>
      <Modal.Content>
        <Modal.ContentText id="unsaved-changes-dialog-description">
          {t('unsavedChanges.message')}
        </Modal.ContentText>
      </Modal.Content>
      <Modal.Actions sx={{ justifyContent: 'flex-start' }}>
        <Buttons.SecondaryDark
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onSave();
          }}
          stretch
        >
          {t('unsavedChanges.save')}
        </Buttons.SecondaryDark>
        <Buttons.SecondaryLight
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDiscard();
          }}
          stretch
        >
          {t('unsavedChanges.discard')}
        </Buttons.SecondaryLight>
      </Modal.Actions>
    </Modal.Container>
  );
}
